import type {ManifestationV4} from 'services/metadata/types';
import type {Schemas} from 'api/dto.generated';
import {ebsApi} from 'store/ebsApi';

const receiveItemsApi = ebsApi.injectEndpoints({
  endpoints: build => ({
    markPhysicalContentReceived: build.mutation<
      Schemas.PhysicalContentReceivedResponse,
      Pick<ManifestationV4, 'ean'>,
      Schemas.PhysicalContentReceivedResponse
    >({
      query: ({ean}) => ({
        url: `manifestation/${ean}/physicalcontentreceived`,
        method: 'POST',
      }),
    }),
  }),
});

export const {useMarkPhysicalContentReceivedMutation} = receiveItemsApi;
